/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListResponse = {
  properties: {
    success: {
      type: 'boolean',
      isRequired: true,
    },
    error: {
      type: 'Error',
    },
    metadata: {
      type: 'Metadata',
    },
  },
} as const;
